document.addEventListener('DOMContentLoaded', function() {
  const popupLinks = document.querySelectorAll('.popup-link');
  
  popupLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const url = this.getAttribute('href');
      window.open(url, 'popup', 'width=800,height=600,scrollbars=yes,resizable=yes');
    });
  });
});